import config from "./config";

function getBaseUrl() {
    return config.zeroKcellUrl
}

export default getBaseUrl